import React from "react";
import {
  Box,
  InputBase,
  Typography,
  Stack,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface Props {
  searchPlaceholder?: string;
  onSearchChange?: (value: string) => void;
  showExport?: boolean;
}

const exportTypes = ["Copy", "CSV", "Excel", "PDF", "Print"];

const SearchandExport: React.FC<Props> = ({
  searchPlaceholder = "Type here",
  onSearchChange,
  showExport = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        mt: 3,
        gap: 2,
      }}
    >
      {/* Search */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { xs: "100%", sm: "300px" },
        }}
      >
        <Typography
          fontSize="16px"
          mb={0.5}
          fontFamily={"Poppins,Semibold"}
        >
          Search
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #ccc",
            px: 1,
            py: 0.5,
          }}
        >
          <SearchIcon color="action" />
          <InputBase
            placeholder={searchPlaceholder}
            sx={{ ml: 1, flex: 1, fontSize: "14px" }}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
        </Box>
      </Box>

      {/* Export */}
      {showExport && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "flex-start", sm: "flex-end" },
          }}
        >
          <Typography
            fontSize="16px"
            mt={1}
            fontFamily={"Poppins,Semibold"}
            
          >
            Export
          </Typography>
          <Stack direction="row" spacing={0} flexWrap="wrap" mt={0.5}>
            {exportTypes.map((label, index) => (
              <Typography 
                key={label}
                sx={{
                  fontSize: "14px",
                  fontFamily: "Poppins,Regular",
                color:"#3E93E8",
                  px: 1,
                  borderRight:
                    index !== exportTypes.length - 0
                      ? "1px solid #ddd"
                      : "none",
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000",
                  },
                }}
              >
                {label}
              </Typography>
            ))}
          </Stack>
        </Box>
      )}
    </Box>
  );
};
export default SearchandExport;
